import { render, staticRenderFns } from "./CarDetail.vue?vue&type=template&id=48c518c0&scoped=true"
import script from "./CarDetail.vue?vue&type=script&lang=js"
export * from "./CarDetail.vue?vue&type=script&lang=js"
import style0 from "./CarDetail.vue?vue&type=style&index=0&id=48c518c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c518c0",
  null
  
)

export default component.exports